import * as yup from 'yup'

export const formValidationSchema = yup
  .object({
    newPassword: yup.string().required('Campo obligatorio'),
    oldPassword: yup.string().required('Campo obligatorio'),
  })
  .required()
